import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-table-summary-header',
  templateUrl: './time-table-summary-header.component.html',
  styleUrls: ['./time-table-summary-header.component.scss']
})
export class TimeTableSummaryHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
